import "@coreui/coreui/dist/css/coreui.min.css";
import {
  Button,
  Typography,
  Box,
  LinearProgress,
  Divider,
  TextField,
  Container,
  Card,
  CardContent,
  ThemeProvider,
  createTheme,
  CircularProgress,
  Fade,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimerIcon from "@mui/icons-material/Timer";
import QuizIcon from "@mui/icons-material/Quiz";
import React, { useMemo, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Rating } from "primereact/rating";
import postApiCall from "src/server/postApiCall";
import { Toast } from "primereact/toast";
import "../../../src/css/quillp.scss";
import "./Quiz.css";
import MultipleChoiceSuperadmin from "./QuizComponents/MultipleChoicesuperadmin";
import MultipleSelectSuperadmin from "./QuizComponents/MultipleSelectsuperadmin";
import TrueFalseSuperadmin from "./TrueFalsesuperadmin";
import YesNoSuperadmin from "./YesNosuperadmin";
import NumericResponseSuperadmin from "./QuizComponents/NumericResponsesuperadmin";
import TextAnswerSuperadmin from "./QuizComponents/TextAnswerSuperadmin";
import FillInTheBlanksSuperadmin from "./QuizComponents/FillInTheBlankssuperadmin";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#00e5ff",
      light: "#33eaff",
      dark: "#00a0b2",
    },
    secondary: {
      main: "#80deea",
    },
    background: {
      default: "#0a1929",
      paper: "#0d2137",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0bec5",
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", sans-serif',
    h5: {
      fontWeight: 600,
      letterSpacing: 0.5,
    },
    h4: {
      fontFamily: '"Orbitron", sans-serif',
      fontWeight: 700,
      letterSpacing: 1,
    },
    question: {
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: 1.5,
      fontFamily: '"Orbitron", sans-serif',
      color: "#00e5ff",
      textShadow: "0 0 10px rgba(0, 229, 255, 0.3)",
    },
    answer: {
      fontSize: "1rem",
      fontFamily: '"Poppins", sans-serif',
      color: "#b0bec5",
      transition: "color 0.2s ease",
      "&:hover": {
        color: "#ffffff",
      },
    },
    answerLabel: {
      fontSize: "0.875rem",
      fontWeight: 500,
      color: "#00e5ff",
      marginBottom: "0.5rem",
      display: "block",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: "none",
          padding: "8px 20px",
          fontSize: "0.9rem",
          fontWeight: 500,
          letterSpacing: "0.5px",
          "&.Mui-disabled": {
            backgroundColor: "rgba(255, 255, 255, 0.12)",
            color: "rgba(255, 255, 255, 0.3)",
            borderColor: "rgba(255, 255, 255, 0.12)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "linear-gradient(45deg, #0d2137 0%, #1a3c5b 100%)",
          border: "1px solid rgba(0, 229, 255, 0.1)",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "rgba(0, 229, 255, 0.5)",
          "&.Mui-checked": {
            color: "#00e5ff",
          },
          "& .MuiSvgIcon-root": {
            fontSize: 28,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "rgba(0, 229, 255, 0.5)",
          "&.Mui-checked": {
            color: "#00e5ff",
          },
          "& .MuiSvgIcon-root": {
            fontSize: 28,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            color: "#ffffff",
            borderRadius: 4,
            backgroundColor: "rgba(0, 229, 255, 0.05)",
            "& fieldset": {
              borderColor: "rgba(0, 229, 255, 0.2)",
            },
            "&:hover fieldset": {
              borderColor: "rgba(0, 229, 255, 0.5)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#00e5ff",
            },
          },
        },
      },
    },
  },
});

function QuizSuperadmin({ detail, sectionType, onClose, isPreview = false }) {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const courseDetail = detail;
  const questionArray = detail?.assessmentDetails?.questionAnswer;
  const [questionAnswerData, setQuestionAnswerData] = useState([]);
  const [evaluationAnswer, setEvaluationAnswer] = useState([]);
  const trainingId1 = window.location.href.split("?")[1] || detail?.trainingId;
  const assessmentId =
    window.location.href.split("?")[3] || detail?.assessmentDetails?.assessmentId;
  const [revealScore, setRevealScore] = useState(false);
  const [questionIdCount, setQuestionIdCount] = useState([]);
  const colorName = localStorage.getItem("ThemeColor");
  const [themes, setThemes] = useState(colorName);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [rating, setRating] = useState(null);
  const [comments, setComments] = useState("");
  const [unload, setUnload] = useState(true);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [evaluationData, setEvaluationData] = useState();
  const [showReview, setShowReview] = useState(false);
  const [showReviewList, setShowReviewlist] = useState(false);
  const [valueReset, setValueReset] = useState(false);
  const [attemptExceeded, setAttemptExceeded] = useState(0);

  useEffect(() => {
    if (courseDetail) {
      if (courseDetail?.assessmentDetails?.displayType === 0) {
        setCurrentIndex(0);
        setQuestionAnswerData(questionArray && [questionArray[0]]);
      } else {
        setQuestionAnswerData(questionArray);
      }
      if (courseDetail?.assessmentDetails?.quizType !== "Quiz") {
        setShowReview(true);
      }
      if (sectionType === "3" && !isPreview) {
        const progressStoreData = {
          trainingCatalogId: trainingId1,
          progressPercentage: 5,
          progressData: {},
        };
        addInProgressCourse(progressStoreData);
      }
    }
  }, [courseDetail, questionArray, sectionType, trainingId1]);

  useEffect(() => {
    if (currentIndex !== -1 && questionArray) {
      setQuestionAnswerData([questionArray[currentIndex]]);
      setCurrentQuestion(currentIndex);
      setValueReset(!valueReset);
    }
  }, [currentIndex, questionArray]);

  const calculateCountdown = (hours, minutes) => {
    return Date.now() + (3600 * Number(hours) + 60 * Number(minutes)) * 1000;
  };

  const showTime = useMemo(
    () => calculateCountdown(courseDetail?.hours, courseDetail?.minutes),
    [courseDetail?.hours, courseDetail?.minutes]
  );

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <span style={{ fontSize: "20px" }}>
          {hours}:{minutes}:{seconds}
        </span>
      );
    } else {
      return (
        <span style={{ fontSize: "20px" }}>
          {hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const handleAnswerChange = (questionId, questionTypeID, value) => {
    setEvaluationAnswer((prev) => {
      const filterValue = prev.filter((item) => item.questionId !== questionId);
      return [
        ...filterValue,
        {
          questionId: questionId,
          questionTypeId: questionTypeID,
          answerValue: value,
        },
      ];
    });
    setQuestionIdCount((pre) => {
      if (!pre.includes(questionId)) {
        return [...pre, questionId];
      }
      return pre;
    });
  };

  const addInProgressCourse = async (payload) => {
    try {
      await postApiCall("addInProgressCourse", payload);
    } catch (error) {
      console.error(error?.response?.data?.error);
    }
  };

  const finalSubmit = async () => {
    const data = {
      evaluationAnswer: evaluationAnswer,
      lastAttemptedQuestion: questionIdCount.length,
      finalSubmit: 1,
      trainingId: parseInt(courseDetail?.trainingId),
      assessmentId: parseInt(assessmentId),
    };
    setLoading(true);
    try {
      const res = await postApiCall("addAssessmentUserAnswers", data);
      if (res) {
        setAttemptExceeded(res?.attemptRemaining);
        setEvaluationData(res);
        setCompleteCourseApi(res?.result);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    finalSubmit();
    setRevealScore(true);
  };

  const buttonClose = () => {
    setUnload(false);
    handleCloseWindow();
  };

  const windowClose = () => {
    if (unload) {
      navigate(`/su/trainings/training-library`);
      onClose();
    }
  };

  const handleCloseWindow = () => {
    setTimeout(() => {
      navigate(`/su/trainings/training-library`);
      onClose();
    }, 4000);
  };

  const setCompleteCourseApi = async (result) => {
    const payLoad = {
      courseId: parseInt(trainingId1),
      resultStatus: result,
    };
    try {
      await postApiCall("studentCompletedCourse", payLoad);
    } catch (error) {
      console.error(error);
    }
  };

  const addUserFeedbackApi = async () => {
    const payLoad = {
      trainingId: parseInt(trainingId1),
      rating: rating,
      feedback: comments,
    };
    try {
      const response = await postApiCall("addUserRating", payLoad);
      if (response) {
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Feedback Sent Successfully",
          life: 3000,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < questionArray?.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleRetakeCourse = () => {
    if (attemptExceeded !== 0) {
      setRevealScore(false);
      setCurrentIndex(0);
      setQuestionAnswerData(
        courseDetail?.assessmentDetails?.displayType === 0
          ? [questionArray[0]]
          : questionArray
      );
      setShowReview(false);
      setShowReviewlist(false);
      setRating(null);
      setComments("");
      setEvaluationAnswer([]);
      setQuestionIdCount([]);
    } else {
      toast?.current?.show({
        severity: "error",
        detail: "Number of attempts exceeded",
        life: 3000,
      });
    }
  };

  // Ensure previous behaviour where closing the window triggers navigation/onClose
  useEffect(() => {
    return () => {
      windowClose();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Toast ref={toast} />
      <Box
          sx={{
            minHeight: "100vh",
            bgcolor: "#1a2035",
            p: { xs: 2, md: 3 },
            backgroundImage:
              "radial-gradient(circle at 50% 50%, rgba(41, 98, 255, 0.03) 0%, rgba(41, 98, 255, 0) 50%)",
          }}
        >
          <Container maxWidth="md">
            <Card
              elevation={24}
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                position: "relative",
                bgcolor: "#0A1929",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "2px",
                  background:
                    "linear-gradient(90deg, transparent, #00e5ff, transparent)",
                },
              }}
            >
              <Box
                sx={{
                  p: 2,
                  background:
                    "linear-gradient(45deg, #0d2137 0%, #1a3c5b 100%)",
                  borderBottom: "1px solid rgba(0, 229, 255, 0.1)",
                  marginTop: "10px",
                  position: "relative",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <QuizIcon sx={{ color: "primary.main", fontSize: 32 }} />
                  <Typography variant="h4" sx={{ color: "primary.main" }}>
                    {courseDetail?.trainingName}
                  </Typography>
                </Box>
                {courseDetail?.assessmentDetails?.timerOn === 1 &&
                  courseDetail?.assessmentDetails?.quizType === "Quiz" && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        mt: 2,
                        color: "text.secondary",
                      }}
                    >
                      <TimerIcon sx={{ fontSize: 20 }} />
                      <Typography variant="h6">
                        Time:{" "}
                        {parseInt(courseDetail?.hours) > 0
                          ? `${courseDetail?.hours}h `
                          : ""}
                        {parseInt(courseDetail?.minutes) > 0
                          ? `${courseDetail?.minutes}m`
                          : ""}
                      </Typography>
                    </Box>
                  )}
              </Box>

              {!revealScore ? (
                <Box sx={{ p: 3 }}>
                  {courseDetail?.assessmentDetails?.quizType === "Quiz" &&
                    courseDetail?.assessmentDetails?.timerOn !== 0 && (
                      <Box sx={{ mb: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 1,
                          }}
                        >
                          <Typography variant="caption" color="text.secondary">
                            Progress
                          </Typography>
                          <Typography variant="caption" color="primary.main">
                            {Math.round(
                              ((currentIndex + 1) /
                                (questionArray?.length || 1)) *
                                100
                            )}
                            %
                          </Typography>
                        </Box>
                        <LinearProgress
                          variant="determinate"
                          value={
                            ((currentIndex + 1) /
                              (questionArray?.length || 1)) *
                            100
                          }
                          sx={{
                            height: 4,
                            borderRadius: 2,
                            bgcolor: "rgba(0, 229, 255, 0.1)",
                            "& .MuiLinearProgress-bar": {
                              background:
                                "linear-gradient(90deg, #00e5ff 0%, #00a0b2 100%)",
                            },
                          }}
                        />
                      </Box>
                    )}

                  <Box sx={{ minHeight: "300px", mb: 3 }}>
                    <Fade in={true} timeout={500}>
                      <Box>
                        {questionAnswerData?.map((item, index) => {
                          switch (item?.questionTypeId) {
                            case 1:
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <MultipleChoiceSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    data={item.answer}
                                    onAnswerChange={handleAnswerChange}
                                    questionID={item.questionId}
                                    questionTypeID={item.questionTypeId}
                                    assessmentID={item.assessmentSettingId}
                                    trainingId1={trainingId1}
                                    assessmentId={assessmentId}
                                    questionIdCount={questionIdCount}
                                  />
                                </Box>
                              );
                            case 2:
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <MultipleSelectSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    data={item.answer}
                                    onAnswerChange={handleAnswerChange}
                                    questionTypeID={item.questionTypeId}
                                    assessmentID={item.assessmentSettingId}
                                    questionID={item.questionId}
                                  />
                                </Box>
                              );
                            case 3:
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <TrueFalseSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    data={item.answer}
                                    onAnswerChange={handleAnswerChange}
                                    questionID={item.questionId}
                                    assessmentID={item.assessmentSettingId}
                                    questionTypeID={item.questionTypeId}
                                  />
                                </Box>
                              );
                            case 4:
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <YesNoSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    data={item.answer}
                                    onAnswerChange={handleAnswerChange}
                                    questionID={item.questionId}
                                    assessmentID={item.assessmentSettingId}
                                    questionTypeID={item.questionTypeId}
                                  />
                                </Box>
                              );

                            case 5: // Text Answer case
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <TextAnswerSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    data={item.answer}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    onAnswerChange={handleAnswerChange}
                                    questionID={item.questionId}
                                    questionTypeID={item.questionTypeId}
                                    trainingId1={trainingId1}
                                    assessmentId={assessmentId}
                                    questionIdCount={questionIdCount}
                                    isCorrect={item.isCorrect}
                                  />
                                </Box>
                              );
                            case 6:
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <NumericResponseSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    data={item.answer}
                                    questionID={item.questionId}
                                    onAnswerChange={handleAnswerChange}
                                    assessmentID={item.assessmentSettingId}
                                    questionTypeID={item.questionTypeId}
                                    valueReset={valueReset}
                                  />
                                </Box>
                              );
                            case 7:
                              return (
                                <Box
                                  sx={{
                                    p: 4,
                                    mb: 3,
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(0, 229, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 100%)",
                                    border: "1px solid rgba(0, 229, 255, 0.1)",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                  }}
                                  key={index}
                                >
                                  <FillInTheBlanksSuperadmin
                                    type={sectionType}
                                    num={currentIndex}
                                    question={item.questionText}
                                    score={
                                      courseDetail?.quizType === "Quiz"
                                        ? item.questionScore
                                        : ""
                                    }
                                    onAnswerChange={handleAnswerChange}
                                    data={item.answer}
                                    questionID={item.questionId}
                                    assessmentID={item.assessmentSettingId}
                                    questionTypeID={item.questionTypeId}
                                    valueReset={valueReset}
                                  />
                                </Box>
                              );
                            default:
                              return <p key={index}>No Quiz</p>;
                          }
                        })}
                      </Box>
                    </Fade>
                  </Box>

                  <Divider
                    sx={{ my: 2, borderColor: "rgba(0, 229, 255, 0.1)" }}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 2,
                      py: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={currentIndex == 0 || !questionArray?.length}
                      onClick={handlePrevClick}
                      startIcon={<NavigateBeforeIcon />}
                      sx={{
                        borderColor: "rgba(0, 229, 255, 0.5)",
                        color: "primary.main",
                        "&:hover": {
                          borderColor: "primary.main",
                          backgroundColor: "rgba(0, 229, 255, 0.08)",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "transparent",
                          borderColor: "rgba(255, 255, 255, 0.12)",
                        },
                      }}
                    >
                      Previous
                    </Button>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        px: 3,
                        py: 0.5,
                        borderRadius: 1,
                        background:
                          "linear-gradient(135deg, rgba(0, 229, 255, 0.1) 0%, rgba(0, 229, 255, 0.05) 100%)",
                        border: "1px solid rgba(0, 229, 255, 0.2)",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <Typography variant="h6" color="primary.main">
                        {currentIndex + 1}
                      </Typography>
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ mx: 1 }}
                      >
                        /
                      </Typography>
                      <Typography variant="h6" color="text.secondary">
                        {
                          courseDetail?.assessmentDetails?.questionAnswer
                            ?.length
                        }
                      </Typography>
                    </Box>

                    <Button
                      variant="outlined"
                      size="small"
                      disabled={
                        !questionArray?.length ||
                        currentIndex ===
                          courseDetail?.assessmentDetails?.questionAnswer
                            ?.length -
                            1
                      }
                      onClick={handleNextClick}
                      endIcon={<NavigateNextIcon />}
                      sx={{
                        borderColor: "rgba(0, 229, 255, 0.5)",
                        color: "primary.main",
                        "&:hover": {
                          borderColor: "primary.main",
                          backgroundColor: "rgba(0, 229, 255, 0.08)",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "transparent",
                          borderColor: "rgba(255, 255, 255, 0.12)",
                        },
                      }}
                    >
                      Next
                    </Button>

                    {sectionType === "3" && !isPreview &&
                      (currentIndex + 1 ===
                        courseDetail?.assessmentDetails?.questionAnswer
                          ?.length ||
                        currentIndex === -1) && (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={handleSubmit}
                          startIcon={<CheckCircleIcon />}
                          sx={{
                            ml: 1,
                            background:
                              "linear-gradient(90deg, #00e676 0%, #00c853 100%)",
                            "&:hover": {
                              background:
                                "linear-gradient(90deg, #00c853 0%, #00b34a 100%)",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: "rgba(255, 255, 255, 0.12)",
                              color: "rgba(255, 255, 255, 0.3)",
                            },
                          }}
                        >
                          Submit
                        </Button>
                      )}
                  </Box>
                </Box>
              ) : (
                <Box sx={{ p: 4 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", p: 4 }}
                    >
                      <CircularProgress size={60} />
                    </Box>
                  ) : (
                    <Fade in={true} timeout={800}>
                      <Box>
                        {courseDetail?.quizType === "Quiz" && !showReview ? (
                          <Box sx={{ textAlign: "center" }}>
                            <CheckCircleIcon
                              sx={{
                                fontSize: 80,
                                mb: 3,
                                color: "#2e7d32",
                                filter:
                                  "drop-shadow(0 4px 8px rgba(46, 125, 50, 0.2))",
                              }}
                            />
                            <Typography
                              variant="h3"
                              gutterBottom
                              fontWeight="700"
                              color="primary.main"
                            >
                              Assessment Completed
                            </Typography>
                            <Typography
                              variant="h5"
                              color="text.secondary"
                              sx={{ mb: 4 }}
                            >
                              {courseDetail?.trainingName}
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                gap: 4,
                                justifyContent: "center",
                                mb: 6,
                              }}
                            >
                              <Card
                                sx={{
                                  minWidth: 240,
                                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                  transition: "transform 0.2s",
                                  "&:hover": {
                                    transform: "translateY(-4px)",
                                  },
                                }}
                              >
                                <CardContent sx={{ textAlign: "center", p: 4 }}>
                                  <Typography
                                    variant="h6"
                                    color="text.secondary"
                                    gutterBottom
                                  >
                                    Total Questions
                                  </Typography>
                                  <Typography
                                    variant="h3"
                                    color="primary.main"
                                    fontWeight="700"
                                  >
                                    {courseDetail?.questionAnswer?.length}
                                  </Typography>
                                </CardContent>
                              </Card>

                              <Card
                                sx={{
                                  minWidth: 240,
                                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                  transition: "transform 0.2s",
                                  "&:hover": {
                                    transform: "translateY(-4px)",
                                  },
                                }}
                              >
                                <CardContent sx={{ textAlign: "center", p: 4 }}>
                                  <Typography
                                    variant="h6"
                                    color="text.secondary"
                                    gutterBottom
                                  >
                                    Questions Attempted
                                  </Typography>
                                  <Typography
                                    variant="h3"
                                    color="primary.main"
                                    fontWeight="700"
                                  >
                                    {questionIdCount?.length}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                gap: 2,
                                justifyContent: "center",
                              }}
                            >
                              <Button
                                variant="contained"
                                size="large"
                                onClick={handleRetakeCourse}
                                sx={{
                                  background:
                                    "linear-gradient(90deg, #1e88e5 0%, #1565c0 100%)",
                                  "&:hover": {
                                    background:
                                      "linear-gradient(90deg, #1976d2 0%, #1255a8 100%)",
                                  },
                                }}
                              >
                                Retake Quiz
                              </Button>
                              {courseDetail.postQuizAction === 1 && (
                                <Button
                                  variant="outlined"
                                  size="large"
                                  onClick={() => {
                                    setShowReview(true);
                                    setShowReviewlist(true);
                                  }}
                                  sx={{
                                    borderWidth: 2,
                                    "&:hover": {
                                      borderWidth: 2,
                                    },
                                  }}
                                >
                                  Review Answers
                                </Button>
                              )}
                            </Box>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              maxWidth: 600,
                              mx: "auto",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="h4"
                              gutterBottom
                              fontWeight="600"
                              color="primary.main"
                            >
                              Your Feedback Matters
                            </Typography>
                            <Typography
                              variant="body1"
                              color="text.secondary"
                              sx={{ mb: 4 }}
                            >
                              Please rate the quality and effectiveness of this
                              training
                            </Typography>
                            <Box sx={{ mb: 4 }}>
                              <Rating
                                id="rating"
                                size={40}
                                value={rating}
                                onChange={(e) => setRating(e.value)}
                                cancel={false}
                                stars={5}
                              />
                            </Box>
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              placeholder="Share your thoughts (Optional)"
                              onChange={(e) => setComments(e.target.value)}
                              sx={{ mb: 4 }}
                            />
                              {!isPreview && (
                                <Button
                                  variant="contained"
                                  size="large"
                                  onClick={() => {
                                    addUserFeedbackApi();
                                    handleCloseWindow();
                                  }}
                                  sx={{
                                    background:
                                      "linear-gradient(90deg, #1e88e5 0%, #1565c0 100%)",
                                    "&:hover": {
                                      background:
                                        "linear-gradient(90deg, #1976d2 0%, #1255a8 100%)",
                                    },
                                  }}
                                >
                                  Submit Feedback
                                </Button>
                              )}
                          </Box>
                        )}
                      </Box>
                    </Fade>
                  )}
                </Box>
              )}
            </Card>
          </Container>
        </Box>
    </ThemeProvider>
  );
}

export default QuizSuperadmin;
